const FEATURES = [
  {
    id: 1,
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '91国产视频全部采用高清编码技术，1080P画质让您看清每一个细节，享受影院级观影体验。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用CDN加速与智能预加载技术，91视频网站页面与播放器秒开无等待，流畅观影不卡顿。',
  },
  {
    id: 3,
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '片库每日更新，91年国产影片、热门电视剧、综艺节目持续上新，精彩内容永不断档。',
  },
  {
    id: 4,
    icon: 'ri-device-line',
    title: '多端适配',
    desc: '支持手机、平板、电脑全终端访问，91国产视频随时随地想看就看，跨设备无缝衔接。',
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    desc: '平台采用先进安全防护体系，保障用户隐私与观影安全，让您放心畅享91视频网站所有内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">平台优势</h2>
          <p className="text-sm md:text-base text-foreground-500">为什么选择91视频网站观看国产影视</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((feature) => (
            <div key={feature.id} className="bg-background-50 rounded-2xl p-5 md:p-6 text-center group cursor-pointer hover:bg-background-200/50 transition-colors">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}